import {Torchlight} from '@/domains/shared/components/Torchlight';
import {
	nodes as defaultNodes,
	Tag,
}                   from '@markdoc/markdoc';
import blogAssetDatabase from '@/domains/blog/databases/assets.json';

const nodes = {
	document: {
		render: undefined,
	},

	th: {
		...defaultNodes.th,
		attributes: {
			...defaultNodes.th.attributes,
			scope: {
				type:    String,
				default: 'col',
			},
		},
	},

	fence: {
		render:     Torchlight,
		attributes: {
			language:    {
				type: String,
			},
			theme:       {
				type:    String,
				default: 'dark-plus',
			},
			includeCopy: {
				type:    Boolean,
				default: true,
			},
			name:        {
				type: String,
			},
		},
	},

	heading: {
		...defaultNodes.heading,
		transform(node, config) {
			const level = node.attributes['level'];
			let children;

			switch (level) {
				case 1, 2: {
					children = [
						{
							'name':       'span',
							'attributes': {
								className: 'underline underline-offset-2 decoration-teal-500 decoration-2 font-medium',
							},
							'children':   node.transformChildren(config),
							'$$mdtag':    true,
						},
					];

					break;
				}

				case 3: {
					children = [
						{
							'name':       'span',
							'attributes': {
								className: 'font-medium',
							},
							'children':   node.transformChildren(config),
							'$$mdtag':    true,
						},
					];

					break;
				}

				default: {
					children = node.transformChildren(config);

					break;
				}
			}

			return new Tag(`h${level}`, node.transformAttributes(config), children);
		},
	},

	image: {
		...defaultNodes.image,
		transform(node, config) {
			const attributes = node.transformAttributes(config);

			/**
			 * If the img src exists in the blog asset database, swap with the updated path.
			 * Otherwise, return the original value
			 */
			attributes.src = blogAssetDatabase[attributes.src] ?? attributes.src;

			return new Tag(
				`img`,
				attributes,
				node.transformChildren(config)
			);
		}
	},
};

export default nodes;
